import React, { useState } from "react";
import { InputText } from "primereact/inputtext";
import { InputMask } from "primereact/inputmask";
import Select from 'react-select';
import "./FamilyMemberContainerStyles.css";
import { FamilyMemberOptions } from "./DropdownOptions/FamilyMemberOptions";
import ApplicationHelper from "../../data/ApplicationHelper";

export default function FamilyMemberContainer(props) {

    const handleChange = (field, value) => {
        if (field === 'name' && !ApplicationHelper.filterNumbersAndSymbols(value)) {
            return;
        }

        props.dispatch({
            type: 'UPDATE_FAMILY_MEMBER',
            index: props.index,
            field: field,
            value: value,
        });
    }

    const handleRemove = () => {
        props.dispatch({
            type: 'REMOVE_FAMILY_MEMBER',
            index: props.index,
        });
    };

    const isNameValid = ApplicationHelper.verifyFullName(props.familyMember.name);

    return (
        <>
            <div className="family-member-add-container">
                <div className="section-item">
                    <label>
                        Relationship:
                        <Select
                            styles={props.selectStyles}
                            menuPortalTarget={document.body}
                            menuPosition={'fixed'}
                            value={props.familyMember.relation}
                            onChange={(option) => { handleChange('relation', option) }} options={FamilyMemberOptions} />
                    </label>
                </div>

                <div className="section-item">

                    <label for="name">
                        Name: {isNameValid ? <i class="fa-solid fa-check green-check"></i> : <i class="fa-thin fa-asterisk red-asterisk" />}

                        <InputText id='name' value={props.familyMember.name} onChange={(event) => { handleChange('name', event.target.value) }} />
                    </label>
                </div>

                <div className="section-item">

                    <label for="birthday">
                        Birthday: {ApplicationHelper.verifyBirthday(props.familyMember.birthday) ? <i class="fa-solid fa-check green-check"></i> : <i class="fa-thin fa-asterisk red-asterisk" />}

                        <InputMask mask="99/99/9999" slotChar="mm/dd/yyyy" value={props.familyMember.birthday} onChange={(event) => handleChange('birthday', event.target.value)} />
                    </label>

                </div>

                <div className="section-item family-member-remove-button-container">
                    <button className="denied-button" onClick={() => handleRemove()}>Remove</button>
                </div>
            </div>
        </>
    )
}